// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanEditWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type {
  UserPropertyFloorPlanEditActiveResponseWebDto,
  UserPropertyFloorPlanEditDateAvailableResponseWebDto,
  UserPropertyFloorPlanEditHighPriceResponseWebDto,
  UserPropertyFloorPlanEditLowPriceResponseWebDto,
  UserPropertyFloorPlanEditNameResponseWebDto,
  UserPropertyFloorPlanEditNumBathroomsResponseWebDto,
  UserPropertyFloorPlanEditNumBedroomsResponseWebDto,
  UserPropertyFloorPlanEditPriceResponseWebDto,
  UserPropertyFloorPlanEditSquareFeetResponseWebDto,
} from '../..';

interface ActiveParams {
  active?: boolean;
  floorPlanId: string;
}
interface DateAvailableParams {
  dateAvailable?: string;
  floorPlanId: string;
}
interface HighPriceParams {
  floorPlanId: string;
  highPrice?: number;
}
interface LowPriceParams {
  floorPlanId: string;
  lowPrice?: number;
}
interface NameParams {
  floorPlanId: string;
  name?: string;
}
interface NumBathroomsParams {
  floorPlanId: string;
  numBathrooms?: number;
}
interface NumBedroomsParams {
  floorPlanId: string;
  numBedrooms?: number;
}
interface PriceParams {
  floorPlanId: string;
  price?: string;
}
interface SquareFeetParams {
  floorPlanId: string;
  squareFeet?: number;
}

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Path =
  '/api/web/v1/users/properties/floorPlans/active';

/**
 * Update activeness of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_active = (
  getParams: ActiveParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<ActiveParams, never, UserPropertyFloorPlanEditActiveResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_active_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Path =
  '/api/web/v1/users/properties/floorPlans/dateAvailable';

/**
 * Update date available of a floor plan, yyyy-MM-dd
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable = (
  getParams: DateAvailableParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<DateAvailableParams, never, UserPropertyFloorPlanEditDateAvailableResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_dateAvailable_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Path =
  '/api/web/v1/users/properties/floorPlans/highPrice';

/**
 * Update the highest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice = (
  getParams: HighPriceParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<HighPriceParams, never, UserPropertyFloorPlanEditHighPriceResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_highPrice_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Path =
  '/api/web/v1/users/properties/floorPlans/lowPrice';

/**
 * Update the lowest price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice = (
  getParams: LowPriceParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<LowPriceParams, never, UserPropertyFloorPlanEditLowPriceResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_lowPrice_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Path =
  '/api/web/v1/users/properties/floorPlans/name';

/**
 * Update name of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_name = (
  getParams: NameParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<NameParams, never, UserPropertyFloorPlanEditNameResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_name_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Path =
  '/api/web/v1/users/properties/floorPlans/numBathrooms';

/**
 * Update number of bathrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms = (
  getParams: NumBathroomsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<NumBathroomsParams, never, UserPropertyFloorPlanEditNumBathroomsResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBathrooms_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Path =
  '/api/web/v1/users/properties/floorPlans/numBedrooms';

/**
 * Update number of bedrooms of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms = (
  getParams: NumBedroomsParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<NumBedroomsParams, never, UserPropertyFloorPlanEditNumBedroomsResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_numBedrooms_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Path =
  '/api/web/v1/users/properties/floorPlans/price';

/**
 * Update price of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_price = (
  getParams: PriceParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<PriceParams, never, UserPropertyFloorPlanEditPriceResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_price_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};

export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Path =
  '/api/web/v1/users/properties/floorPlans/squareFeet';

/**
 * Update square feet of a floor plan
 */
export const RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet = (
  getParams: SquareFeetParams,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<SquareFeetParams, never, UserPropertyFloorPlanEditSquareFeetResponseWebDto>({
    getParams: getParams,
    endpoint: RentalManagerUserPropertyFloorPlanEditWebApiHandler_squareFeet_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    environment,
  });
};
